// libs
import { styled } from '@nykaa/ui-components';

// components
import Chips from '@nykaa/ui-components/Chips';
import { LegendDot } from 'shared/layouts/DetailsPage/components/ProductInfo/components/SizeOptions/styles';
import StockInfo from './StockInfo';
import { FOCUS_VISIBILITY_CSS } from 'shared/styles/base';

export { Info } from './StockInfo.styles';

export const ButtonV2 = styled.button<{
  selected: boolean;
  width: number;
  disabled?: boolean;
  isRevampedQuickView?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  width: max-content;
  ${({ theme }) => ` padding: 6px ${theme.spacing.spacing60}`};
  ${({ theme }) => theme.typography.bodyMedium};
  min-width: 51px;
  height: 32px;
  border-radius: 24px;
  border: 1px solid ${({ theme }) => theme.colors.textOutline};
  ${({ width }) => (width === 0 ? `width: auto` : `width: ${width}px`)};
  white-space: nowrap;
  background: transparent;
  cursor: pointer;
  ${({ selected, theme }) =>
    selected &&
    `
    border: 1px solid ${theme.colors.sizeSelected};
    background: ${theme.colors.textDecorative};
  `};
  color: ${({ theme }) => theme.colors.textPrimary};
  ${({ disabled, isRevampedQuickView, theme }) =>
    disabled &&
    `
    opacity: ${isRevampedQuickView ? 1 : 0.8};
  pointer-events: none;
  color: ${isRevampedQuickView ? '#0013255C' : theme.colors.textDisabled};
  border-color: ${isRevampedQuickView ? '#00132529' : theme.colors.textDisabled};
  `};

  ${FOCUS_VISIBILITY_CSS}
`;

export const Button = styled(Chips) <{ selected: boolean; disabled?: boolean; }>`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  width: max-content;
  ${({ selected, theme }) => !selected && `color: ${theme.colors.textPrimary}`};
  ${({ disabled, theme }) =>
    disabled &&
    `
    opacity: 0.8;
  pointer-events: none;
  color: ${theme.colors.textDisabled};
  border-color: ${theme.colors.textDisabled};
  `};

  ${FOCUS_VISIBILITY_CSS}
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  margin-right: ${({ theme }) => theme.spacing.spacing40};
  &&:last-child {
    margin-right: none;
  }
`;

export const StockIndicators = styled(LegendDot) <{ isSelected: boolean; }>`
  height: 8px;
  width: 8px;
  position: absolute;
  top: 2px;
  right: 0px;
  transition: transform 0.2s ease-out;
  ${({ isSelected }) => isSelected && `transform: scale(0)`};
  ${({ theme }) => `outline: ${theme.borders.radius10} solid ${theme.colors.surface}`};
`;

export const StockInfoV2 = styled(StockInfo)`
  ${({ theme }) => theme.typography.bodySmall};
`;
